module.exports = __webpack_public_path__ + "assets/c56480678d6a395f98edc4a3b4b681cf.mp3";